import { render } from "./bannerCermiSemanal.vue?vue&type=template&id=22626c46&scoped=true&lang=html"
import script from "./bannerCermiSemanal.vue?vue&type=script&lang=js"
export * from "./bannerCermiSemanal.vue?vue&type=script&lang=js"

import "./bannerCermiSemanal.vue?vue&type=style&index=0&id=22626c46&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22626c46"]])

export default __exports__